module.exports = __webpack_public_path__ + "static/img/ruwei.ba96025.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ruwei.png
// module id = u6UA
// module chunks = 1